import { render, staticRenderFns } from "./Weixin.vue?vue&type=template&id=a15a200a&scoped=true&"
import script from "./Weixin.vue?vue&type=script&lang=js&"
export * from "./Weixin.vue?vue&type=script&lang=js&"
import style0 from "./Weixin.vue?vue&type=style&index=0&id=a15a200a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a200a",
  null
  
)

export default component.exports